import { Box, HStack, Switch, Text, VStack, makeUclComponent } from '@rbilabs/universal-components';

import Link from 'components/link';
import { primitive } from 'styles/constants/primitives';

export const CommPreferenceLabel = Text.withConfig({
  variant: 'headerThree',
  marginBottom: '$2',
  fontSize: 'lg',
});

export const CommPreferenceDescription = Text.withConfig({
  fontSize: 'md',
  margin: '$0',
  marginBottom: '$4',
});

export const ToggleContainer = HStack.withConfig(
  ({ hideBottomBorder }: { hideBottomBorder?: boolean }) => ({
    ...(!hideBottomBorder && { borderBottomWidth: 1, borderBottomColor: Styles.color.grey.ten }),
    paddingY: '$4',
    width: '100%',
    _web: {
      paddingRight: 2,
    },
    _android: {
      paddingRight: 2,
    },
  })
);

export const ToggleLabelContainer = VStack.withConfig({
  flex: 1,
});

export const ToggleLabel = Text.withConfig({
  variant: 'copyTwo',
  fontSize: 'md',
});

export const ToggleDescription = Text.withConfig(({ isDisabled }: { isDisabled?: boolean }) => ({
  ...(isDisabled && { color: primitive.$blackOpacity50 }),
}));

export const ToggleButton = Switch.withConfig({
  offTrackColor: primitive.$blackOpacity50,
  onTrackColor: primitive.bk.$crunchyGreen,
});

export const LoadingToggleContainer = HStack.withConfig({
  marginRight: '$4',
});

export const InputContainer = Box.withConfig({
  marginBottom: '$3',
  width: '100%',
});

export const PermissionsContainer = Box.withConfig({
  marginBottom: '$3',
});

export const StyledOptInLink = makeUclComponent(Link).withConfig({
  isInline: true,
  isUnderlined: true,
});
